import { SalesRemissionDetailPrintModel } from "./sales-remission-detail-print.model";

export class SalesRemissionPrintModel {
    inventoryOutputId: number = 0;
    branchId: number = 0;
    branchCode: string = '';
    branchName: string = '';
    address: string = '';
    phone: string = '';
    inventoryId: number = 0;
    inventoryCode: string = '';
    inventoryName: string = '';
    consecutive: string = '';
    dateSalesRemission: Date = new Date();
    clientId: number = 0;
    clientNit: string = '';
    clientName: string = '';
    observation: string | null = null;
    userAuthenticated: string = '';
    salesRemissionDetails: SalesRemissionDetailPrintModel[] = [];
}